$(document).ready(function() {
    $('#cart-form-summary').on('submit', function () {
		$.redirect('/koszyk', { action: 'order_confirmation' }, 'POST')
	})
});